import theme from '@theme-ui/preset-tailwind';

export const opacities = {
  ...(theme.opacities && theme.opacities),
};
